// extracted by mini-css-extract-plugin
module.exports = {"watch-video":"_11bp8","watchVideo":"_11bp8"};